"use client";

import { useCampaignTagsForProduct } from "@/features/campaigns/hooks";
import { Tags, Tag } from "@/components/ui/Tags";
import { useGlobal } from "@/features/global/GlobalContext";
import { Translate } from "@/components/Translate";
import styles from "./ProductDetailsPage.module.css";
import type { ProductCard, ProductDetails } from "@/lib/centra";

interface ProductDetailsCampaignTagsProps {
	product: {
		displayItemId: string;
		sku?: string;
		centraProductNumber?: string;
	};
}

export const ProductDetailsCampaignTags = ({ product }: ProductDetailsCampaignTagsProps) => {
	const campaignTags = useCampaignTagsForProduct(product as ProductCard);
	const { data: globalData } = useGlobal();

	if (campaignTags.length === 0) {
		return null;
	}

	return (
		<Tags className={styles.campaignTags}>
			{campaignTags.map((tag) => {
				const colorEntry = tag.color ? globalData.colorMap[tag.color] : undefined;
				return (
					<Tag
						key={tag.name}
						filled
						style={
							colorEntry
								? ({
										"--tag-color": colorEntry.color,
										"--tag-foreground": colorEntry.foreground,
									} as React.CSSProperties)
								: undefined
						}
					>
						<Translate>{tag.name}</Translate>
					</Tag>
				);
			})}
		</Tags>
	);
};
